module.exports = __webpack_public_path__ + "img/map_siracusa.20c93333.png";